import React, { useContext, useRef, useState, useCallback } from 'react';
import { mapContext } from '../Services/MapContext';

import './MapControls.css';

function Controls(props) {
	const { onToggleFilter, searchFocused, data, setSelectedData, language } = props;
	const { map, layersLoaded } = useContext(mapContext);
	
	const [searchbarValue, setSearchbarValue] = useState('');
	const [searchbarMenuOpen, setSearchbarMenuOpen] = useState(false);
	const [searchbarSuggestions, setSearchbarSuggestions] = useState([]);
	const buttonParent = useRef();

	// Search string in map data
	const searchInData = (string) => {
		const searchString = string.toLowerCase();
		return data.features.filter(el => el.properties.NAME.toLowerCase().includes(searchString));
	}

	// Handle searchbar input change
	const onSearchbarChange = async (e) => {
		setSearchbarValue(e.target.value);
		if (e.target.value.length >= 1) {
			const results = searchInData(e.target.value);
			setSearchbarSuggestions(results);
		}
		if (e.target.value === '') setSearchbarSuggestions([]);
	}

	// When user clicks elsewhere
	const onInputClickOut = (e) => {
		if (e.relatedTarget) setSearchbarMenuOpen(false);
	}

	// Cluck on a suggestion
	const onSuggestionClick = useCallback((suggestion) => {
		if (!suggestion) return;

		// Add event to fire once we jump to the point
		map.once('moveend', (e) => {
			if (!e.originalEvent) {
				// wait for features to load and update coordinates
				map.once('idle', (e) => {
					//handleLocationMarkerCoords(coords);
				});
			}
		});
		// Jump to the point
		if (suggestion?.geometry?.coordinates) {
			map.easeTo({
				zoom: 10,
				center: suggestion.geometry.coordinates,
				duration: 1200
			});
		}

		setSelectedData(suggestion.properties);
		setSearchbarValue('');
		setSearchbarMenuOpen(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [map, layersLoaded]);

	// Handling zoom in/out
	const clickZoomIn = (e) => {
		let currentZoom = map.getZoom();
		map.flyTo({zoom: currentZoom+1})
	}
	const clickZoomOut = (e) => {
		let currentZoom = map.getZoom();
		map.flyTo({zoom: currentZoom-1})
	}

	const placeholderText = (language && language['map:controls:search']) ? language['map:controls:search'] : 'Search';

	return (
		<>
			<div className="controls-left">
				<button type="button" className="gp-button filter" onClick={onToggleFilter}></button>


				<div className="searchbar-wrapper">

					<div className="search-input-wrapper">
						<div className="search-btn" role="none" tabIndex="-1"></div>
						<input
							ref={searchFocused}
							className="search-input"
							type="text"
							id={placeholderText}
							placeholder={placeholderText}
							aria-label={placeholderText}
							value={searchbarValue}
							onChange={onSearchbarChange}
							onFocus={() => setSearchbarMenuOpen(true)}
							onBlur={onInputClickOut}
						/>
					</div>

					{searchbarMenuOpen && searchbarSuggestions.length > 0 && (
						<div className="searchbar-suggestions">
							<div className="searchbar-suggestions-content">
								{searchbarSuggestions.map((suggestion, index) => {
									return (
										<div
											key={index}
											className="suggestion"
											onClick={() => onSuggestionClick(suggestion)}
										>
											{suggestion.properties.NAME}
										</div>
									);
								})}
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="controls-right">
				<div className="zoom-wrapper">
					<button type="button" className="gp-button zoom-in" onClick={clickZoomIn}></button>
					<button type="button" className="gp-button zoom-out" onClick={clickZoomOut}></button>
				</div>
				<div className="gp-button-block" ref={buttonParent} />
				{/*<button type="button" className="gp-button info" onClick={onToggleInfo}></button>*/}
			</div>
		</>
	);
}

export default Controls;
